import React from "react";
import { SovosBox, SovosTypography } from "mosaic-react";
import { aiBrandLinearGradient315 } from "mosaic-react-platform/shared/aiBrandGradient";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const SOVI_AI_ORB_SX = {
    background: (theme) => aiBrandLinearGradient315(theme.palette.primary.main),
    borderRadius: (theme) => theme.shape.borderRadiusRound || "50%",
    flexShrink: 0,
    height: 18,
    width: 18,
};

const StagingIssueHoverCard = () => {
    const { i18n } = useGlobalValue();

    return (
        <SovosBox
            sx={{
                bgcolor: "common.white",
                display: "flex",
                flexDirection: "column",
                gap: 0.75,
                px: 2,
                py: 1.5,
                width: 280,
            }}
        >
            <SovosBox sx={{ alignItems: "center", display: "flex", gap: 1 }}>
                <SovosBox aria-hidden sx={SOVI_AI_ORB_SX} />
                <SovosTypography
                    fontWeight={700}
                    sx={{ color: "text.primary", fontSize: 14, lineHeight: "20px" }}
                    variant="subtitle2"
                >
                    {i18n`No AI suggestion found`}
                </SovosTypography>
            </SovosBox>
            <SovosTypography
                sx={{ color: "text.secondary", fontSize: 12, lineHeight: 1.5, pl: 3.5 }}
                variant="body2"
            >
                {i18n`Double click to edit the cell manually`}
            </SovosTypography>
        </SovosBox>
    );
};

export default StagingIssueHoverCard;
